import { useAppSelector } from '@/redux/hooks'
import { useEcommerceFilter } from '@/hooks/use-selected-ecommerce-ids'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { Base } from '@itsrever/design-system'
import { useProcesses } from '@/hooks/use-processes-v2'
import ErrorIcon from '@mui/icons-material/ErrorOutlineOutlined'
import { Platforms, Roles } from '@/utils'
import {
  CoverBanner,
  FeaturedReverProducts,
  MainChart
} from '@/ui/components/home'
import { REVIEW_REQUIRED } from '@/ui/components/processes/processes-tabs'
import { PickScope } from '@/ui/shared'

const { Card, Button } = Base

export function Home() {
  const { t, i18n } = useTranslation()

  const role = useAppSelector((s) => s.userApi.getMe.response.user?.role)
  const showMainChart = role !== Roles.Reviewer

  const platform = useAppSelector(
    (s) => s.settingsApi.settings.response.platform
  )

  const isShopify = platform === Platforms.Shopify

  const ecommerceId = useEcommerceFilter()

  const { data: reviewRequiredProcesses } = useProcesses({
    ecommerce_id: ecommerceId,
    return_status: REVIEW_REQUIRED
  })

  return (
    <div className="flex h-full flex-col items-center p-6">
      <div className="w-full max-w-5xl">
        {isShopify ? <CoverBanner /> : <FeaturedReverProducts />}
        {showMainChart ? (
          <PickScope>
            <MainChart />
          </PickScope>
        ) : null}
        {reviewRequiredProcesses?.rowcount &&
        Number(reviewRequiredProcesses.rowcount) > 0 ? (
          <div className="space-y-3 pt-8">
            <h6>{t('home_page.actions_pending')}</h6>
            <Card className="p-4">
              <div className="flex items-center gap-3">
                <ErrorIcon className="text-red-400" />
                <p>
                  <Trans
                    i18nKey={'home_page.pending_processes'}
                    values={{
                      reviewRequiredProcesses: Number(
                        reviewRequiredProcesses.rowcount
                      ).toLocaleString(i18n.language)
                    }}
                    components={{ strong: <strong /> }}
                  />
                </p>
                <Button
                  variant="secondary"
                  className="ml-auto"
                  render={
                    <Link
                      to={`/returns/orders?return_status=${REVIEW_REQUIRED}`}
                    />
                  }
                >
                  {t('home_page.review_pending_processes')}
                  <svg
                    width="14px"
                    height="14px"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    color="currentColor"
                  >
                    <path
                      d="M3 12L21 12M21 12L12.5 3.5M21 12L12.5 20.5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Button>
              </div>
            </Card>
          </div>
        ) : null}
      </div>
    </div>
  )
}
